import { Component, OnInit, AfterViewInit } from '@angular/core';
import { WebcamImage, WebcamUtil } from 'ngx-webcam';
import { Subject, Observable } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';

declare var $: any;
@Component({
  selector: 'app-componente-camera',
  templateUrl: './componente-camera.component.html',
  styleUrls: ['./componente-camera.component.scss']
})
export class ComponenteCameraComponent implements OnInit, AfterViewInit {

  public sintomarfoto = true;
  public multipleCamarasDisponibles = false;
  private trigger: Subject<void> = new Subject<void>();
  public webCamImage: WebcamImage = null;
  public botonEditar = false;
  public botonCapturar = true;
  public fototomada = false;


  constructor(private activeModal: NgbActiveModal, private spiner: NgxSpinnerService) {
    this.spiner.show();
   }

  ngOnInit() {
    
    WebcamUtil.getAvailableVideoInputs().then((mediaDevices: MediaDeviceInfo[]) => {
      this.multipleCamarasDisponibles = mediaDevices && mediaDevices.length > 1;
    });

    setTimeout(() => {
      this.ocultarSpinner();
    }, 2000);
  }

  ngAfterViewInit() {
    $('#video div').addClass('embed-responsive embed-responsive-4by3');
    $('#video div video').addClass('embed-responsive-item');
  }

  public ocultarSpinner() {
    this.spiner.hide();
  }

  public triggerSnapshot() {
    this.trigger.next();
    this.sintomarfoto = false;
    this.fototomada = true;
  }

  public handleImage(webcamImage: WebcamImage) {
    this.webCamImage = webcamImage;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  close() {
    this.activeModal.close({ imageAsDataUrl: this.webCamImage, imageBase64: this.webCamImage.imageAsBase64 });

    // emite la lista de agendas que se ingresaron en el modal
  }

}
